import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { getImageById, getTextById } from "../../commons/constants/helpers";
import { IProps } from "../../types/CommonTypes";
import { useEffect, useRef, useState } from "react";
import "./Banner.css";

const Banner = ({ item }: IProps) => {
	const [profileLoaded, setProfileLoaded] = useState(false);
	const profileRef = useRef<HTMLImageElement>(null);

	// Si la foto ya venía en caché, el evento `load` puede haber ocurrido antes de
	// que React montara el handler: sin este chequeo se quedaría en opacity 0.
	useEffect(() => {
		if (profileRef.current?.complete) setProfileLoaded(true);
	}, []);

	const backgroundImage = getImageById("banner", item);
	const profileImage = getImageById("profile", item);
	const title = getTextById("title", item);
	const subtitle = getTextById("subtitle", item) ?? "";

	// El primer párrafo del subtítulo es el cargo (va en el chip); el resto, la bio.
	const [lead, ...rest] = subtitle.split("\n\n").filter((p) => p.trim());
	const body = rest.length ? rest.join("\n\n") : subtitle;

	const handleScrollToAbout = () => {
		document.querySelector("#about")?.scrollIntoView({
			behavior: "smooth",
		});
	};

	// El hero es contenido above-the-fold: se pinta de inmediato y las entradas
	// son animaciones CSS que arrancan al montar. Nada aquí puede depender de que
	// una imagen termine de bajar ni de que el usuario haga scroll.
	return (
		<section
			id="inicio"
			className="banner-hero"
			style={{ backgroundImage: `url("${backgroundImage}")` }}
		>
			<div className="banner-content">
				<div className="banner-text-section">
					{rest.length > 0 && (
						<p className="banner-eyebrow banner-in banner-in-1">{lead}</p>
					)}

					<div className="banner-title-block banner-in banner-in-2">
						<h1 className="banner-title">{title}</h1>
						<span className="banner-brand-line" aria-hidden="true" />
					</div>

					<p className="banner-subtitle banner-in banner-in-3">{body}</p>

					<div className="banner-ctas banner-in banner-in-4">
						<a className="ld-btn ld-btn-yellow" href="#gestion">
							Conoce mi gestión
						</a>
						<a className="ld-btn ld-btn-ghost" href="#denuncias">
							Denuncia aquí
						</a>
					</div>
				</div>

				<div className="banner-image-section">
					<img
						ref={profileRef}
						src={profileImage}
						alt="Daniel Briceño"
						className={`banner-profile-image${
							profileLoaded ? " is-loaded" : ""
						}`}
						loading="eager"
						fetchPriority="high"
						decoding="async"
						onLoad={() => setProfileLoaded(true)}
						onError={() => setProfileLoaded(true)}
					/>
				</div>
			</div>

			<button
				className="banner-scroll-indicator"
				onClick={handleScrollToAbout}
				aria-label="Ir a la sección Sobre mí"
			>
				<KeyboardArrowDownIcon />
			</button>
		</section>
	);
};

export default Banner;
